import React, { useEffect, useState } from "react";
import request from "axios";
import moment from "moment";
import LoadingMessage from "../loadingMessage";
import ReferencesForm from "./referencesForm";

const References = props => {
  const [name, setName] = useState("");
  const [niNumber, setNiNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [responsibleTeam, setResponsibleTeam] = useState("");
  const [consentDate, setConsentDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [formState, setFormState] = useState(null);
  const [referenceData, setReferenceData] = useState(null);
  const [expiration, setExpiration] = useState("Valid");

  const Messages = Object.freeze({
    ERROR_WRONG_URL:
      "This URL is invalid. Please check the provided URL address and try again",
    ERROR_UNKNOWN:
      "There has been an error in submitting your reference form.  Please try again or if the error persists, please email online@hrgo.co.uk with details of the reference.",
    SUCCESS: "Your reference was saved. Thank you."
  });

  const { token } = props.match.params;

  const setData = data => {
    setName(data.name);
    setNiNumber(data.niNumber);
    setDateOfBirth(`${moment(data.dateOfBirth).format("Do MMMM YYYY")}`);
    if (data.consentDate) {
      setConsentDate(`${moment(data.consentDate).format("Do MMMM YYYY")}`);
    }
    setResponsibleTeam(data.responsibleTeam);
  };

  const handleError = (error, data) => {
    if (error.response && error.response.status === 400) {
      setMessage(Messages.ERROR_WRONG_URL);
    } else {
      setMessage(Messages.ERROR_UNKNOWN);
      if (data) {
        setFormState(data.reference);
      }
    }
    setLoading(false);
  };

  const displayForm = () => !loading && name && !message;

  const saveReference = data => {
    setReferenceData(data);
    setLoading(true);
    return request
      .post(
        `${process.env.REACT_APP_FONT_API_ENDPOINT}/candidate-reference`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}`
          }
        }
      )
      .then(() => setLoading(false))
      .then(() => setMessage(Messages.SUCCESS))
      .then(() => setFormState(null))
      .catch(err => handleError(err, data));
  };

  useEffect(() => {
    request
      .get(
        `${process.env.REACT_APP_FONT_API_ENDPOINT}/check-reference/${token}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}`
          }
        }
      )
      .then(res => setExpiration(res.data));

    request
      .get(
        `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/candidate/${token}`,
        {}
      )
      .then(({ data }) => setData(data))
      .then(() => setLoading(false))
      .catch(err => handleError(err));
  }, []);

  const ReferenceHeader = () => (
    <div className="text-center border mb-2">
      <h4> Reference Request </h4>{" "}
      <p>
        HR GO Recruitment has authority to request a reference(s) on behalf of
        the employee.If you are not the intended recipient you must not read,
        copy, distribute or disseminate this communication to anyone other than
        the addressee or use the information it contains.The information you
        provide may be shared with other prospective employers and with the
        employee.If you have any questions, please contact the HR GO consultant
        who emailed you this reference request.Thank you for your time.{" "}
      </p>{" "}
    </div>
  );

  const ReferenceConsent = () => (
    <div
      className={displayForm() ? "text-center border mb-2 bg-white" : "d-none"}
    >
      <h4> Consent </h4>{" "}
      <p> This person consented to us requesting references: </p>{" "}
      <p>
        {" "}
        {name} {consentDate}{" "}
      </p>{" "}
      <p className="signature"> {name} </p>{" "}
    </div>
  );

  const ReferencesFormWrapper = () => (
    <div className="mb-2">
      {" "}
      {displayForm() && expiration === "Valid" && (
        <ReferencesForm
          token={token}
          name={name}
          niNumber={niNumber}
          dateOfBirth={dateOfBirth}
          responsibleTeam={responsibleTeam}
          saveReference={saveReference}
          initialState={formState}
        />
      )}{" "}
    </div>
  );

  const LoadingComponent = () => (
    <div
      style={{ position: "relative", width: "100%", height: "100%" }}
      className={loading ? "" : "d-none"}
    >
      <LoadingMessage />
    </div>
  );

  const MessageComponent = () =>
    !loading && (
      <div className={message ? "d-block text-center" : "d-none"}>
        <div
          className={
            message === Messages.SUCCESS ? "successMessage" : "errorMessage"
          }
        >
          {" "}
          {message}{" "}
        </div>{" "}
        {message !== Messages.SUCCESS && (
          <div className="text-center">
            <button
              className="btn btn-primary tw-mt-4"
              onClick={() => saveReference(referenceData)}
            >
              Try Again{" "}
            </button>{" "}
          </div>
        )}{" "}
      </div>
    );

  const DisplayStatusComponent = () => (
    <div className={"mb-2"}>
      <LoadingComponent />
      <MessageComponent />
    </div>
  );

  const ReferencesWrapper = () =>
    expiration === "Expired" ? (
      <div className="pt-3">
        <ReferenceHeader />
        <div style={{ padding: "5rem 0" }} className="d-block text-center">
          <div className="errorMessage">
            The reference has already been submitted. <br />
            The link has expired.{" "}
          </div>{" "}
        </div>{" "}
      </div>
    ) : (
      <div className="pt-3">
        <ReferenceHeader />
        <DisplayStatusComponent />
        <ReferenceConsent />
        <ReferencesFormWrapper />
      </div>
    );

  return <ReferencesWrapper />;
};

export default References;
